export default [
    {
        path: "/admin/bank-profiles",
        name: "bank-profile",
        meta: { requiresAuth: true },
        component: () =>
            import("@/pages/finance/bank-profile/index.vue")
    },
    {
        path: "/admin/bank-profiles/create",
        name: "bank-profile-create",
        meta: { requiresAuth: true },
        component: () =>
            import("@/pages/finance/bank-profile/create.vue")
    },
    {
        path: "/admin/bank-profiles/:id/edit",
        name: "bank-profile-edit",
        meta: { requiresAuth: true },
        component: () =>
            import("@/pages/finance/bank-profile/edit.vue")
    }
];
